// FullCalendar Vue3: expose component for local registration where needed.
// Avoid global registration to keep bundle size in check.
import FullCalendar from '@fullcalendar/vue3'

export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      FullCalendar,
    },
  }
})
